import CombinedScoreBadge from './CombinedScoreBadge'

export default function MatchTierIndicator({ 
  matchTier, 
  matchScore, 
  matchReason,
  // New props for combined score display
  combinedScore,
  soloConfidence,
  scheduleFit,
  distanceScore,
  distanceMiles
}) {
  // If combined score is available, use the new CombinedScoreBadge component
  if (combinedScore !== null && combinedScore !== undefined) {
    return (
      <CombinedScoreBadge
        combinedScore={combinedScore}
        soloConfidence={soloConfidence}
        scheduleFit={scheduleFit}
        distanceScore={distanceScore}
        distanceMiles={distanceMiles}
        matchReason={matchReason}
      />
    )
  }

  // Fallback to tier-based display if no combined score
  if (matchTier === null || matchTier === undefined) return null

  const tierConfig = {
    1: {
      icon: '🟢',
      label: 'Perfect Match',
      description: 'Your team is completely free',
      className: 'bg-green-50 border-green-200 text-green-900',
      badgeClass: 'bg-green-100 text-green-800'
    },
    2: {
      icon: '🟡',
      label: 'Great Match',
      description: '2+ hour gap before/after practice',
      className: 'bg-yellow-50 border-yellow-200 text-yellow-900',
      badgeClass: 'bg-yellow-100 text-yellow-800'
    },
    3: {
      icon: '🟠',
      label: 'Possible Match',
      description: 'Could cancel adjacent practice',
      className: 'bg-orange-50 border-orange-200 text-orange-900',
      badgeClass: 'bg-orange-100 text-orange-800'
    },
    4: {
      icon: '🔵',
      label: 'Tight Fit',
      description: '4+ hour gap before/after game',
      className: 'bg-blue-50 border-blue-200 text-blue-900',
      badgeClass: 'bg-blue-100 text-blue-800'
    },
    0: {
      icon: '🔴',
      label: 'Not a Match',
      description: 'Schedule conflict',
      className: 'bg-red-50 border-red-200 text-red-900',
      badgeClass: 'bg-red-100 text-red-800'
    }
  }

  const config = tierConfig[matchTier] || tierConfig[0]

  return (
    <div className={`rounded-lg border px-3 py-2.5 ${config.className}`}>
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          <span className="text-lg">{config.icon}</span>
          <div>
            <div className="font-semibold text-sm">{config.label}</div>
            <div className="text-xs opacity-80">{matchReason || config.description}</div>
          </div>
        </div>
        {matchScore !== null && matchScore !== undefined && (
          <div className={`px-2 py-1 rounded text-xs font-bold ${config.badgeClass}`}>
            {matchScore} pts
          </div>
        )}
      </div>
    </div>
  )
}

